import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import React, { useCallback } from "react";
import { message } from "antd";
import { api } from "../../../api";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../../externalComponents/tailwind/dropdown";
import { useNavigate } from "react-router-dom";

const ChatbotsActionsDropdown = ({ customerId, chatbot, setListData }) => {
  const navigate = useNavigate();

  const handleArchiverClick = useCallback(() => {
    setListData((_listData) => ({
      ..._listData,
      isModalOpen: true,
      chatbotToChange: chatbot,
    }));
  }, [setListData, chatbot]);

  const handleDuplicateClick = useCallback(async () => {
    setListData((_listData) => ({
      ..._listData,
      chatbotToChange: chatbot,
      isModalDuplicateOpen: true,
      loadingRow: chatbot.id,
    }));
  }, [chatbot]);

  const handleStatusChange = useCallback(async () => {
    console.log("chatbot", chatbot);
    if (!chatbot.rootNode?.whatsappTrigger) {
      console.warn(
        "Cannot change status: rootNode or whatsappTrigger is missing",
        chatbot,
      );
      message.warning(
        "Cannot activate or deactivate the chatbot at the moment. Please try again later.",
      );
      return;
    }
    setListData((_listData) => ({
      ..._listData,
      chatbotToChange: chatbot,
      loadingRow: chatbot.id,
      isStatusLoading: true,
    }));
    const active = chatbot.status === "active";
    try {
      await api.whatsappTrigger.update(chatbot.rootNode.whatsappTrigger.id, {
        status: active ? "inactive" : "active",
      });
      if (chatbot.chatbotType === "autoreply") {
        await api.customer.update(customerId, {
          automaticReplyNode: {
            _link: active ? null : chatbot.rootNode.id,
          },
        });
      }
      if (chatbot.chatbotType === "whatsapp_order") {
        await api.customer.update(customerId, {
          whatsappOrderNode: {
            _link: active ? null : chatbot.rootNode.id,
          },
        });
      }
      await api.scenario.update(chatbot.id, {
        status: active ? "inactive" : "active",
      });
    } finally {
      setListData((_listData) => ({
        ..._listData,
        isStatusLoading: false,
      }));
    }
  }, [chatbot]);

  const { status, id } = chatbot;
  return (
    <Dropdown>
      <DropdownButton plain aria-label="More options">
        <EllipsisHorizontalIcon />
      </DropdownButton>
      <DropdownMenu anchor="bottom end">
        <DropdownItem onClick={handleArchiverClick}>Archive</DropdownItem>
        <DropdownItem onClick={handleStatusChange}>
          {status === "active" ? "Turn-Off" : "Turn-On"}
        </DropdownItem>
        <DropdownItem onClick={handleDuplicateClick}>Duplicate</DropdownItem>
        <DropdownItem onClick={() => navigate(`/chatbots/edit/${id}`)}>
          Edit
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ChatbotsActionsDropdown;
